import { AxiosResponse } from 'axios'
import api from 'Services/api'

import { Estabelecimento } from '../../../hooks/estabelecimento/useEstabelecimentos/types'
import { EstabelecimentoApi } from './types'

const ESTABELECIMENTO_BASE_URL = '/cadastro/estabelecimento'
const ESTABELECIMENTO_MINIFICADO_BASE_URL = '/cadastro/estabelecimento/minificado'

const estabelecimentoApiService = {
  getById(idestabelecimento: string): Promise<AxiosResponse<EstabelecimentoApi>> {
    return api.get(`${ESTABELECIMENTO_BASE_URL}/${idestabelecimento}/`)
  },
  list(): Promise<AxiosResponse<EstabelecimentoApi[]>> {
    return api.get('/core/estabelecimento/me/')
  },
  listLicencas(): Promise<AxiosResponse<any>> {
    return api.get('/core/estabelecimento/licencas/')
  },
  updateById(idestabelecimento: string, data: Partial<Estabelecimento>): Promise<AxiosResponse<EstabelecimentoApi>> {
    return api.put(`${ESTABELECIMENTO_BASE_URL}/${idestabelecimento}/`, data)
  },
  listEstabelecimentos(): Promise<AxiosResponse<EstabelecimentoApi[]>> {
    return api.get(`${ESTABELECIMENTO_BASE_URL}/`)
  },
  replicatePrecos(origem: string, destino: string): Promise<AxiosResponse<any>> {
    return api.post('/core/acoes/replicar_precos/', { origem, destino })
  },
  listaEstabelecimentosMinificados(): Promise<AxiosResponse<EstabelecimentoApi[]>> {
    return api.get(`${ESTABELECIMENTO_MINIFICADO_BASE_URL}/`)
  }
}

export default estabelecimentoApiService
